import React from 'react'
import { Breadcrumb } from './Breadcrumb'
import { Container } from 'react-bootstrap'
import { DeleteRequestForm } from './DeleteRequestForm'

export const Page = () => {
  return (
    <>
      <Breadcrumb title="Request Deletion Of User Data" />

      <Container className="my-5">
        <p>
          To comply with Apple and Google account deletion policy, you can request to us if you want to remove your user data (e.g. email address and
          name) from our database. Please take note that if we delete your data you cannot recover it nor can use the TotalMilk apps.
        </p>

        <div className="my-2">
          <DeleteRequestForm />
        </div>
      </Container>
    </>
  )
}

export default Page
